module.exports = __webpack_public_path__ + "static/media/03.770c227a.png";